import { sendAxiosRequest } from '../../utils/sendRequest';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IResponse from '../../../models/responces/IResponse';

export interface IApiConfirmOrdersParams {
  ids: number[];
}
const apiConfirmOrders = (params: IApiConfirmOrdersParams) =>
  sendAxiosRequest({
    method: 'post',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'order',
      action: 'confirm',
      id: params.ids.join(',')
    }),
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IResponse>;
export default apiConfirmOrders;
